 const redirectLinks = [
  {
    old: "https://ezfycode.com/products/ultimate-speed-enabler",
    newUrl: "https://ezfycode-shop.fourthwall.com/products/ultimate-speed-enabler"
  },
  {
    old: "https://ezfycode.com/products/ultimate-speed-enabler/",
    newUrl: "https://ezfycode-shop.fourthwall.com/products/ultimate-speed-enabler"
  },
  {
    old: "https://ezfycode.com/blog/add-custom-fonts-to-shopify",
    newUrl: "https://ezfycode.com/blogs/shopify-tutorials/add-custom-fonts-to-shopify"
  },
  {
    old: "https://ezfycode.com/shop",
    newUrl: "https://ezfycode.com/collections/all"
  },
  {
    old: "https://ezfycode.com/portfolio",
    newUrl: "https://ezfycode.com/pages/portfolio"
  },
  {
    old: "https://ezfycode.com/license",
    newUrl: "https://ezfycode.com/pages/license"
  },
  {
    old: "https://ezfycode.com/ecwid-upsell-checkout-privacy-policy",
    newUrl: "https://ezfycode.com/pages/ecwid-upsell-checkout-privacy-policy"
  },
  {
    old: "https://ezfycode.com/app-detector",
    newUrl: "https://ezfycode.com/pages/app-detector"
  },
  {
    old: "https://ezfycode.com/about",
    newUrl: "https://ezfycode.com/pages/about"
  },
  {
    old: "https://ezfycode.com/shop/custom-font",
    newUrl: "https://ezfycode.com/products/custom-font"
  },
  {
    old: "https://ezfycode.com/shop/age-verification-popup",
    newUrl: "https://ezfycode.com/products/age-verification-popup"
  },
  {
    old: "https://ezfycode.com/shop/brooklyn-theme-slider-pro",
    newUrl: "https://ezfycode.com/products/brooklyn-theme-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/debut-theme-slider-pro",
    newUrl: "https://ezfycode.com/products/debut-theme-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/debut-theme-second-image-on-hover",
    newUrl: "https://ezfycode.com/products/debut-theme-second-image-on-hover"
  },
  {
    old: "https://ezfycode.com/shop/debut-theme-sticky-navbar-pro",
    newUrl: "https://ezfycode.com/products/debut-theme-sticky-navbar-pro"
  },
  {
    old: "https://ezfycode.com/shop/minimal-theme-slider-pro",
    newUrl: "https://ezfycode.com/products/minimal-theme-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/responsive-image-section-pro",
    newUrl: "https://ezfycode.com/products/responsive-image-section-pro"
  },
  {
    old: "https://ezfycode.com/shop/debut-read-more",
    newUrl: "https://ezfycode.com/products/debut-read-more"
  },
  {
    old: "https://ezfycode.com/shop/debut-theme-zoom-pro",
    newUrl: "https://ezfycode.com/products/debut-theme-zoom-pro"
  },
  {
    old: "https://ezfycode.com/shop/supply-theme-slider-pro",
    newUrl: "https://ezfycode.com/products/supply-theme-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/minimal-theme-second-image-on-hover",
    newUrl: "https://ezfycode.com/products/minimal-theme-second-image-on-hover"
  },
  {
    old: "https://ezfycode.com/shop/slideshow-section-pro",
    newUrl: "https://ezfycode.com/products/slideshow-section-pro"
  },
  {
    old: "https://ezfycode.com/shop/anti-theft-disable-right-click",
    newUrl: "https://ezfycode.com/products/anti-theft-disable-right-click"
  },
  {
    old: "https://ezfycode.com/shop/dawn-theme-read-more",
    newUrl: "https://ezfycode.com/products/dawn-theme-read-more"
  },
  {
    old: "https://ezfycode.com/shop/simple-theme-slider-pro",
    newUrl: "https://ezfycode.com/products/simple-theme-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/dawn-theme-slider-pro",
    newUrl: "https://ezfycode.com/products/dawn-theme-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/dawn-theme-zoom-slider-pro",
    newUrl: "https://ezfycode.com/products/dawn-theme-zoom-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/craft-theme-zoom-slider-pro",
    newUrl: "https://ezfycode.com/products/dawn-theme-zoom-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/studio-theme-zoom-slider-pro",
    newUrl: "https://ezfycode.com/products/dawn-theme-zoom-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/sense-theme-zoom-slider-pro",
    newUrl: "https://ezfycode.com/products/dawn-theme-zoom-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/collections-tabs",
    newUrl: "https://ezfycode.com/products/collections-tabs"
  },
  {
    old: "https://ezfycode.com/shop/refresh-theme-zoom-slider-pro",
    newUrl: "https://ezfycode.com/products/dawn-theme-zoom-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/origin-theme-zoom-slider-pro",
    newUrl: "https://ezfycode.com/products/dawn-theme-zoom-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/ride-theme-zoom-slider-pro",
    newUrl: "https://ezfycode.com/products/dawn-theme-zoom-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/taste-theme-zoom-slider-pro",
    newUrl: "https://ezfycode.com/products/dwan-theme-zoom-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/crave-theme-zoom-slider-pro",
    newUrl: "https://ezfycode.com/products/dawn-theme-zoom-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/colorblock-theme-zoom-slider-pro",
    newUrl: "https://ezfycode.com/products/dawn-theme-zoom-slider-pro"
  },
  {
    old: "https://ezfycode.com/shop/text-scroller",
    newUrl: "https://ezfycode.com/products/text-scroller"
  },
  {
    old: "https://ezfycode.com/blog/optimize-shopify-product-page-images",
    newUrl: "https://ezfycode.com/blogs/shopify-tutorials/optimize-shopify-product-page-images"
  },
  {
    old: "https://ezfycode.com/blog/shopify-remove-your-shop-name-from-the-website-title",
    newUrl: "https://ezfycode.com/blogs/shopify-tutorials/shopify-remove-your-shop-name-from-the-website-title"
  },
  {
    old: "https://ezfycode.com/blog/remove-powered-by-shopify-from-footer",
    newUrl: "https://ezfycode.com/blogs/shopify-tutorials/remove-powered-by-shopify-from-footer"
  },
  {
    old: "https://ezfycode.com/blog/debut-shopify-theme-how-to-add-swipe-for-product-page-images",
    newUrl: "https://ezfycode.com/blogs/shopify-tutorials/debut-shopify-theme-how-to-add-swipe-for-product-page-images"
  },
  {
    old: "https://ezfycode.com/blog/shopify-fix-leverage-browser-caching",
    newUrl: "https://ezfycode.com/blogs/shopify-tutorials/shopify-fix-leverage-browser-caching"
  },
  {
    old: "https://ezfycode.com/blog/hide-price-for-sold-out-products-debut-theme",
    newUrl: "https://ezfycode.com/blogs/shopify-tutorials/hide-price-for-sold-out-products-debut-theme"
  },
  {
    old: "https://ezfycode.com/blog/how-to-disable-right-click-image-and-text-copying-without-apps",
    newUrl: "https://ezfycode.com/blogs/shopify-tutorials/how-to-disable-right-click-image-and-text-copying-without-apps"
  },
      {
    "old": "/blog/dawn-theme-add-a-read-more-button-to-the-product-page",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/dawn-theme-add-a-read-more-button-to-the-product-page"
  },
  {
    "old": "/blog/debut-theme-resize-header-logo",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/debut-theme-resize-header-logo"
  },
  {
    "old": "/blog/how-to-fix-logo-empty-space",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/how-to-fix-logo-empty-space"
  },
  {
    "old": "/blog/dawn-theme-move-title-above-images-on-product-pages",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/dawn-theme-move-title-above-images-on-product-pages"
  },
  {
    "old": "/blog/simple-theme-product-page-slideshow-tutorial",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/simple-theme-product-page-slideshow-tutorial"
  },
  {
    "old": "/blog/dawn-theme-product-page-slideshow-with-arrows-tutorial",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/dawn-theme-product-page-slideshow-with-arrows-tutorial"
  },
  {
    "old": "/blog/dawn-theme-how-to-fix-zoom-images-size-mobile-desktop",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/dawn-theme-how-to-fix-zoom-images-size-mobile-desktop"
  },
  {
    "old": "/blog/dawn-theme-how-to-customize-badges-color-and-size",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/dawn-theme-how-to-customize-badges-color-and-size"
  },
  {
    "old": "/blog/keep-sticky-header-visible-after-scrolling",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/keep-sticky-header-visible-after-scrolling"
  },
  {
    "old": "/blog/craft-theme-vertical-thumbnails-and-arrows-tutorial",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/craft-theme-vertical-thumbnails-and-arrows-tutorial"
  },
  {
    "old": "/blog/remove-options-from-the-collection-filter-shopify",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/remove-options-from-the-collection-filter-shopify"
  },
  {
    "old": "/blog/change-any-text-on-your-shopify-store-works-on-all-themes",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/change-any-text-on-your-shopify-store-works-on-all-themes"
  },
  {
    "old": "/blog/how-to-hide-out-of-stock-products",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/how-to-hide-out-of-stock-products"
  },
  {
    "old": "/blog/studio-theme-adding-vertical-thumbnails-and-arrows-to-the-product-page-images",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/studio-theme-adding-vertical-thumbnails-and-arrows-to-the-product-page-images"
  },
  {
    "old": "/blog/add-text-below-hamburger-menu",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/add-text-below-hamburger-menu"
  },
  {
    "old": "/blog/search-bar-always-visible-tutorial",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/search-bar-always-visible-tutorial"
  },
  {
    "old": "/blog/how-to-detect-the-theme-and-apps-from-any-shopify-store",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/how-to-detect-the-theme-and-apps-from-any-shopify-store"
  },
  {
    "old": "/blog/refresh-atheme-vertical-thumbnails-with-arrow-navigation-on-product-pages-no-apps",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/refresh-atheme-vertical-thumbnails-with-arrow-navigation-on-product-pages-no-apps"
  },
  {
    "old": "/blog/collection-with-tabs-shopify-section-tutorial",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/collection-with-tabs-shopify-section-tutorial"
  },
  {
    "old": "/blog/choose-which-image-to-show-on-hover-instead-of-the-second-one",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/choose-which-image-to-show-on-hover-instead-of-the-second-one"
  },
  {
    "old": "/blog/show-mobile-slideshows-text-on-top-of-image",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/show-mobile-slideshows-text-on-top-of-image"
  },
  {
    "old": "/blog/change-how-many-variants-are-shown-per-row",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/change-how-many-variants-are-shown-per-row"
  },
  {
    "old": "/blog/the-best-slideshow-apps-on-shopify",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/the-best-slideshow-apps-on-shopify"
  },
  {
    "old": "/blog/how-to-change-product-images-with-arrow-keys",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/how-to-change-product-images-with-arrow-keys"
  },
  {
    "old": "/blog/how-to-add-name-field-to-newsletter-free-themes",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/how-to-add-name-field-to-newsletter-free-themes"
  },
  {
    "old": "/blog/find-shopify-collaborator-code",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/find-shopify-collaborator-code"
  },
  {
    "old": "/blog/add-color-swatches-to-the-product-page-no-apps",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/add-color-swatches-to-the-product-page-no-apps"
  },
  {
    "old": "/blog/display-price-inside-add-to-cart-button",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/display-price-inside-add-to-cart-button"
  },
  {
    "old": "/blog",
    "newUrl": "https://xwh1tv-pp.myshopify.com/blogs/shopify-tutorials"
  },
  {
    "old": "/blogs/news/how-to-add-a-name-field-to-the-newsletter-section-all-free-themes",
    "newUrl": "/blogs/news/how-to-add-name-field-to-newsletter-free-themes"
  },
  {
    "old": "/blogs/shopify-tutorials/display-products-price-inside-add-to-cart-button",
    "newUrl": "/blogs/shopify-tutorials/display-price-inside-add-to-cart-button"
  },
     {
    "old": "https://ezfycode.com/blogs/shopify-tutorials/studio-theme-adding-vertical-thumbnails-and-arrows-to-the-product-page-images",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/dawn-theme-product-page-slideshow-with-arrows-tutorial"
  },

      {
    "old": " https://ezfycode.com/blogs/shopify-tutorials/studio-theme-adding-vertical-thumbnails-and-arrows-to-the-product-page-images",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials/dawn-theme-product-page-slideshow-with-arrows-tutorial"
  },

         {
    "old": "https://ezfycode.com/blogs",
    "newUrl": "https://ezfycode.com/blogs/shopify-tutorials"
  },

];


setTimeout(() => {

function redirectIfNeeded() {
  const url = new URL(window.location.href);
  let cleanPath = url.pathname.replace(/\/$/, ''); // Remove trailing slash if any
  const cleanUrl = url.origin + cleanPath; // Removes query string and hash

  const match = redirectLinks.find(link => link.old.trim() === cleanUrl.trim());

  if (match) {
    window.location.href = match.newUrl;
  }
}

redirectIfNeeded();


},100)